import SplitMenuController from "./split_menu_controller"

// Classification-only behavior: do not change other toolbar dropdowns.
export default class extends SplitMenuController {
    static targets = ["empty"]

    connect() {
        super.connect()
        this.pending = new Set()
        this.loaded = new Set()
        this.requests = new Set()
        this.filterOptions()
    }

    disconnect() {
        this.requests.forEach(controller => controller.abort())
        super.disconnect()
    }

    open() {
        super.open()
        this.loadCounts()
    }

    filterOptions() {
        if (!this.hasFilterTarget) return
        const query = this.filterTarget.value.trim().toLowerCase()
        this.groupTargets.forEach(group => {
            let visible = false
            group.querySelectorAll('[data-message-category-target="item"]').forEach(item => {
                item.hidden = !item.dataset.label.toLowerCase().includes(query)
                visible ||= !item.hidden
            })
            group.hidden = !visible
        })
        this.emptyTarget.hidden = this.itemTargets.some(item => !item.hidden)
        if (this.menuTarget.classList.contains("is-open")) this.loadCounts()
    }

    async loadCounts() {
        // Two requests at a time; opening the menu never blocks the message list.
        if (!this.loaded) return
        const next = this.itemTargets.find(item => !item.hidden && !this.loaded.has(item) && !this.pending.has(item))
        if (!next || this.pending.size >= 2 || !this.element.isConnected) return
        this.pending.add(next)
        const controller = new AbortController()
        this.requests.add(controller)
        this.loadCounts()
        const badge = next.querySelector('.message-category-count')
        try {
            const response = await fetch(next.dataset.countUrl, { headers: { Accept: "application/json" }, signal: controller.signal })
            if (!response.ok) throw new Error("Count unavailable")
            const result = await response.json()
            badge.textContent = `${result.count}${result.bounded ? "+" : ""}`
            badge.setAttribute("aria-label", `${result.bounded ? "At least " : ""}${result.count} matching threads`)
            badge.title = result.bounded ? "Results are limited to the matching search window" : "Matching threads"
        } catch (error) {
            if (error.name !== "AbortError") {
                badge.textContent = "—"
                badge.setAttribute("aria-label", "Count unavailable")
            }
        } finally {
            this.pending.delete(next)
            this.loaded.add(next)
            this.requests.delete(controller)
            if (this.menuTarget.classList.contains("is-open")) this.loadCounts()
        }
    }
}
